import { Theme } from "@mui/material/styles";
import { createGlobalStyle } from "styled-components";

// styled-components types the theme as an empty object inside
// createGlobalStyle, so read tokens through the MUI theme type instead.
const token =
  (pick: (theme: Theme) => string) =>
  (props: { theme: unknown }) =>
    pick(props.theme as Theme);

// Page-level base styles. Lives next to the theme so body colors follow the
// active theme instead of being hardcoded in index.css.
const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  html, body, #root {
    height: 100%;
  }

  body {
    margin: 0;
    font-family: ${token((theme) => theme.fontFamily)};
    font-size: 15px;
    font-weight: 400;
    line-height: 1.45;
    font-feature-settings: "cv11", "ss01";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${token((theme) => theme.textColor)};
    background-color: ${token((theme) => theme.bodyBackground)};
    color-scheme: ${token((theme) => (theme.name === "dark" ? "dark" : "light"))};
  }

  button, input, textarea, select {
    font-family: inherit;
  }

  code {
    font-family: ${token((theme) => theme.monoFontFamily)};
  }

  ::selection {
    background: ${token((theme) => theme.colors.primarySoft)};
  }

  a:focus-visible,
  button:focus-visible,
  [role="button"]:focus-visible {
    outline: 2px solid ${token((theme) => theme.colors.primary)};
    outline-offset: 2px;
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: ${token((theme) => theme.borderStrong)} transparent;
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: ${token((theme) => theme.borderStrong)};
    border-radius: 8px;
    border: 2px solid transparent;
    background-clip: content-box;
  }
`;

export default GlobalStyle;
